/** UI route permissions. Backend authorization remains authoritative. */
export const RoleMenu: Record<string, string[]> = {
  dashboard_view: [
   '/main',
 
    '/nrp',
    '/approvals',
    '/approval-workflows',
    '/chain-list',
    '/workflow-chain',
    '/price-recommendation',
    '/user-access',
    '/audit',
    '/discount-templates',
    '/discount-request',
    '/domain-catalogs',
    '/customer-catalogs',
    '/price-list-catalogs',
  ],
  dashboard_admin: [
    '/main',
    '/home-main',
    '/approvals',
    
    '/approval-workflows',
    '/chain-list',
    '/workflow-chain',
    '/price-recommendation',
    '/user-access',
    '/audit',
    '/discount-templates',
    '/discount-request',
    '/domain-catalogs',
    '/customer-catalogs',
    '/price-list-catalogs',
  ],
  full_view: [
   '/main',
    '/approvals',
    '/nrp',
    '/home-main',
    '/approval-workflows',
    '/chain-list',
    '/workflow-chain',
    '/price-recommendation',
    '/user-access',
    '/audit',
    '/discount-templates',
    '/discount-request',
    '/domain-catalogs',
    '/customer-catalogs',
    '/price-list-catalogs',
  ],
};
